<template>
    <div>
        <Modal :gray-header="false" size="md" @close="$emit('close')">
            <template #body>
                <div class="flex flex-col items-center px-4">
                    <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            cx="32"
                            cy="32"
                            r="28"
                            fill="white"
                            stroke="#C6F6D5"
                            stroke-width="8"
                        />
                        <path
                            d="M21 33L28.3333 40L43 26"
                            stroke="#48BB78"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>

                    <h4 class="mt-[22px] text-xl font-bold text-green-600">
                        {{ $t("vue.thank_you_for_payment") }}
                    </h4>

                    <div
                        class="mt-3 max-w-sm text-center text-sm text-gray-500"
                    >
                        <p>
                            {{ $t("vue.payment_successful_message") }}
                            <inertia-link
                                :href="route('billing.subscriptions.index')"
                                class="text-topol-blue-500 font-medium"
                                >{{ $t("vue.your_receipt_here") }}</inertia-link
                            >.
                        </p>
                        <p class="mt-5">
                            {{ $t("vue.charge_error_questions") }}
                            <a
                                class="font-medium text-custom-blue-500 hover:text-custom-blue-600"
                                href="mailto:info@mail.dmarceye.com"
                                >{{ $t("vue.info_email") }}</a
                            >.
                        </p>
                    </div>
                    <div class="pb-11">
                        <inertia-link :href="route('home')">
                            <AtomicButton color="yellow" size="md" class="mt-8">
                                {{ $t("vue.lets_get_started") }}
                            </AtomicButton>
                        </inertia-link>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>
<script lang="ts" setup>
import route from "ziggy-js";

defineEmits(["close"]);
</script>
